import Thankyou from "../../common/ThankyouPage/Thankyou.jsx";
import React, { Component } from "react";
import Header from "../../common/Header/HeaderMain";
import Footer from "../../common/Footer/FooterMain";
class DisaggThankyouPage extends Component {
  render() {
    return (
      <>
        <div className="disagg-thankyou">
          <Header configs={this.props.configs}/>
          <Thankyou userObj={this.props.userObj} translations={this.props.translations} />
          <Footer configs={this.props.configs} translations={this.props.translations} footerNote={this.props.translations.data["FOOTER.FAQ_PAGE.FOOTER_NOTE"]}/>
        </div>
      </>
    );
  }
}

export default DisaggThankyouPage;
